import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
  customProperties: true,
  iconfont: 'md',
  theme: {
    primary: '#D11218',
    accent: '#556677'
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js